// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import Welcome from '@/views/Welcome.vue'
import IntroIChingDaily from '@/views/IntroIChingDaily.vue'
//import Login from '@/views/Login.vue'
//import Signup from '@/views/Signup.vue'
import SetupUserData from '@/views/SetupUserData.vue'
import SetupSajuData from '@/views/SetupSajuData.vue'
import RecoverUserData from '@/views/RecoverUserData.vue'
import IChingDaily from '@/views/IChingDaily.vue'
import IntroDaily from '@/views/IntroDaily.vue'
import FiveElementDaily from '@/views/FiveElementDaily.vue'
import IntroFortune from '@/views/IntroFortune.vue'
import FortuneThisYear from '@/views/FortuneThisYear.vue'
import IntroMBTI from '@/views/IntroMBTI.vue'
import MBTI from '@/views/MBTI.vue'
import IntroDivination from '@/views/IntroDivination.vue'
import Divination from '@/views/Divination.vue'
import Interpretation from '@/views/Interpretation.vue'
import IntroHexagram from '@/views/IntroHexagram.vue'
import HexagramToday from '@/views/HexagramToday.vue'
import Hexagrams from '@/views/Hexagrams.vue'
import HexagramDetail from '@/views/HexagramDetail.vue'
import Meditation from '@/views/Meditation.vue'
import ChargeLydia from '@/views/ChargeLydia.vue'
import HexagramShow from '@/components/HexagramShow.vue'
import UserInfo from '@/views/UserInfo.vue'
import { historyStack, lastRoute } from '@/store/history.js'
import AdminView from '@/views/admin/AdminView.vue'
import IntroView from '@/views/IntroView.vue'
import Guide from '@/views/policy/Guide.vue'
import PrivacyPolicy from '@/views/policy/PrivacyPolicy.vue'
import PointPolicy from '@/views/policy/PointPolicy.vue'
import Channels from '@/views/Channels.vue'

import { doc, setDoc, getDoc, serverTimestamp } from 'firebase/firestore'
import { db } from '@/firebase'

const routes = [
  { path: '/', component: IntroView },
  { path: '/IntroView', name: 'IntroView', component: IntroView }, 
  { path: '/policy/Guide', name: 'Guide', component: Guide },
  { path: '/policy/PrivacyPolicy', name: 'PrivacyPolicy', component: PrivacyPolicy },
  { path: '/policy/PointPolicy', name: 'PointPolicy', component: PointPolicy },
  { path: '/Welcome', name: 'Welcome', component: Welcome },
  { path: '/IntroIChingDaily', name: 'IntroIChingDaily', component: IntroIChingDaily },
  { path: '/SetupUserData', name: 'SetupUserData', component: SetupUserData },
  { path: '/SetupSajuData', name: 'SetupSajuData', component: SetupSajuData },
  { path: '/RecoverUserData', name: 'RecoverUserData', component: RecoverUserData },
  { path: '/IChingDaily', name: 'IChingDaily', component: IChingDaily },
  { path: '/FiveElementDaily', name: 'FiveElementDaily', component: FiveElementDaily },
  { path: '/FortuneThisYear', name: 'FortuneThisYear', component: FortuneThisYear },
  { path: '/MBTI', name: 'MBTI', component: MBTI },
  { path: '/Divination', name: 'Divination', component: Divination },
  { path: '/Interpretation', name: 'Interpretation', component: Interpretation },
  { path: '/IntroDaily', name: 'IntroDaily', component: IntroDaily },
  { path: '/IntroFortune', name: 'IntroFortune', component: IntroFortune },
  { path: '/IntroMBTI', name: 'IntroMBTI', component: IntroMBTI },
  { path: '/IntroDivination', name: 'IntroDivination', component: IntroDivination },
  { path: '/IntroHexagram', name: 'IntroHexagram', component: IntroHexagram },
  { path: '/HexagramToday', name: 'HexagramToday', component: HexagramToday },
  { path: '/Hexagrams', name: 'Hexagrams', component: Hexagrams },
  { path: '/Hexagrams/:name', name: 'HexagramDetail', component: () => import('@/views/HexagramDetail.vue'), props: true },
  { path: '/Meditation', name: 'Meditation', component: Meditation },
  { path: '/ChargeLydia', name: 'ChargeLydia', component: ChargeLydia },
  { path: '/UserInfo', name: 'UserInfo', component: UserInfo },
  { path: '/Channels', name: 'Channels', component: Channels },
  { path: '/PushDetail', name: 'PushDetail', component: () => import('@/views/PushDetail.vue') },
  // 게시판
  { 
    path: '/board', 
    name: 'Board', 
    component: () => import('@/views/board/BoardList.vue') 
  },
  {
    path: '/board/write',
    name: 'BoardWrite',
    component: () => import('@/views/board/BoardWrite.vue'),
  },
  {
    path: '/board/:id',
    name: 'BoardDetail',
    component: () => import('@/views/board/BoardDetail.vue'),
  },
  {
    path: '/admin',
    component: AdminView,
    beforeEnter: async (to, from, next) => {
      const accessToken = localStorage.getItem('accessToken')
      if (!accessToken) return next('/')

      const userDoc = await getDoc(doc(db, 'users', accessToken))
      if (userDoc.exists() && userDoc.data().isAdmin) {
        next() // 관리자일 경우 진입 허용
      } else {
        alert('관리자만 접근 가능합니다.')
        next('/IChingDaily') // 접근 차단
      }
    },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

let previousRoute = '/'

router.beforeEach((to, from, next) => {
  lastRoute.value = from.path
  previousRoute = from.path

  console.log('이동: ', from.path, ' -> ', to.path)
  console.log('쿼리: ', from.query, ' -> ', to.query)
  if (from.path === '/' && to.path === '/ChargeLydia') {
    // Bootpay.requestPayment 결과 redirect 되어 ChargeLydia가 뜨는 경우 / --> ChargeLydia로 경로가 잡히면서 to.query에 Redirect URL이 포함되어 있다.
    // 이 경우. 그대로 ChargeLydia로 이동한다.
    if (to.query.status) next()
    // Redirect 되어 뜬 ChargeLydia에서 후속 처리가 끝나고 router.go(-1)을 할 때 다시 Bootpay.requestPayment을 호출한 ChargeLydia가 뜨게 되는데,이때는 to.query가 비어있다.
    // 이 경우, 메뉴화면으로 이동한다.
    else next('/IChingDaily')
  } else next()
})

// 라우터 이동 후, 매번 Gtag에 페이지뷰 전송
router.afterEach((to, from) => {
  // Gtag이 전역으로 노출되어 있는지 확인
  if (typeof window.gtag === 'function') {
    // 페이지 경로와 제목을 매개변수로 전달
    window.gtag('event', 'page_view', {
      'page_path': to.path,
      'page_title': to.name || 'Untitled Page', // 라우트 메타 필드에서 제목 가져오기 가능
    });
  }
});

const protectedPaths = [
  '/HexagramToday',
  '/FiveElementDaily',
  '/FortuneThisYear',
  '/MBTI',
  '/Divination',
  '/Interpretation',
]
const publicPaths = ['/SetupUserData', '/RecoverUserData']

// 브라우저의 popstate 이벤트 리스닝
window.addEventListener('popstate', (event) => {
  // Vue Router의 현재 경로와 브라우저의 히스토리 상태 등을 비교하여 원하는 동작 수행
  // 예: 특정 경로에서는 뒤로 가기 대신 홈으로 이동
  console.log('popstate event captured at: ', previousRoute)
  if (protectedPaths.includes(previousRoute)) {
    router.push('/IChingDaily')
  } else {
    if (publicPaths.includes(previousRoute)) {
      router.push('/')
    }
    // 기본 뒤로 가기 동작 유지 (Vue Router가 처리)
    // router.back() 를 명시적으로 호출할 수도 있습니다.
  }
})

window.addEventListener('keydown', (event) => {
  // 왼쪽 화살표 키 (keyCode 37 또는 event.key 'ArrowLeft') 감지
  if (event.key === 'ArrowLeft' || event.keyCode === 37) {
    // 기본 브라우저 뒤로 가기 동작 방지
    event.preventDefault()
    console.log('ArrowLeft key captured: ', previousRoute)
    // Vue Router를 사용하여 원하는 라우트로 이동 또는 로직 수행
    if (protectedPaths.includes(previousRoute)) {
      router.push('/IChingDaily')
    } else {
      if (publicPaths.includes(previousRoute)) {
        router.push('/')
      }
    }
  }
})

export default router
